import { render, staticRenderFns } from "./UserDeptsCard.vue?vue&type=template&id=0ccd5cd3&scoped=true"
import script from "./UserDeptsCard.vue?vue&type=script&lang=ts"
export * from "./UserDeptsCard.vue?vue&type=script&lang=ts"
import style0 from "./UserDeptsCard.vue?vue&type=style&index=0&id=0ccd5cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd5cd3",
  null
  
)

export default component.exports